export const W_NOT_STARTED =  'workshop_not_started';
export const W_CHECK_RESPONSE = 'workshop_check_response';
export const W_TRAINE_PROGRESS =  'workshop_trainee_progress';
export const W_COMPLETED = 'workshop_completed';
export const M_NOT_STARTED = 'module_not_started';
export const M_SUBMITED = 'module_submited';
export const M_COMPLETED = 'module_completed';
export const M_INPROGRESS = 'module_in_progress';
export const Q_NOT_STARTED ='question_not_started';
export const Q_SUBMITED = 'question_submited';
export const Q_COMPLETED = 'question_completed';
export const Q_FAILED = 'question_failed';

export const TRAINEE = 'trainee';
export const PROVIDER = 'provider';
export const PURCHASED = 'purchased';

export const BUTTON_START = 'view responses';
export const BUTTON_COMPLETE = 'completed';
export const BUTTON_PROGRESS = 'progress';
export const BUTTON_TAKE = 'take quiz';
export const BUTTON_NOT_STARTED = 'incomplete';


export const TARGET_FILE_CONTENT_TYPES = ['application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  'application/vnd.ms-word.document.macroEnabled.12',
  'application/vnd.ms-word.template.macroEnabled.12'];
export const TARGET_FILE_MAX_SIZE = 5 * 1024 * 1024;


export const SUBMIT_MODULE = '/api/v1/modules/submit_module/?module_id=';

export const RESPONSE_AVERAGE = 0;
export const RESPONSE_GOOD = 1;
export const RESPONSE_EXELENT = 2;

export const RESPONSE_ANSWERED_KEY = {
              'excellent': RESPONSE_EXELENT,
              'good':     RESPONSE_GOOD,
              'average':  RESPONSE_AVERAGE
            }


// WEBPACK FOOTER //
// ./src/components/providers/online_workshop_details/constants.js